import React from "react";
import Svg, { G, Path, Circle, Polygon, Rect } from "react-native-svg";

const EmptyBadge = ({ size = 88 }) => {
  return (
    <Svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      preserveAspectRatio="xMidYMin meet"
    >
      <Rect width="48" height="48" rx="24" fill="#F0F0F5" />
      <Path
        d="M30.6667 19.9997C30.6667 18.2316 29.9643 16.5359 28.7141 15.2856C27.4638 14.0354 25.7682 13.333 24 13.333C22.2319 13.333 20.5362 14.0354 19.286 15.2856C18.0358 16.5359 17.3334 18.2316 17.3334 19.9997C17.3334 20.3533 17.4739 20.6924 17.7239 20.9425C17.9739 21.1925 18.3131 21.333 18.6667 21.333C19.0203 21.333 19.3595 21.1925 19.6095 20.9425C19.8596 20.6924 20 20.3533 20 19.9997C20 19.2085 20.2346 18.4352 20.6742 17.7774C21.1137 17.1196 21.7384 16.6069 22.4693 16.3042C23.2002 16.0014 24.0045 15.9222 24.7804 16.0765C25.5563 16.2309 26.2691 16.6118 26.8285 17.1712C27.3879 17.7307 27.7688 18.4434 27.9232 19.2193C28.0775 19.9952 27.9983 20.7995 27.6956 21.5304C27.3928 22.2613 26.8801 22.886 26.2223 23.3256C25.5645 23.7651 24.7912 23.9997 24 23.9997C23.6464 23.9997 23.3073 24.1402 23.0572 24.3902C22.8072 24.6402 22.6667 24.9794 22.6667 25.333V27.9997C22.6667 28.3533 22.8072 28.6924 23.0572 28.9425C23.3073 29.1925 23.6464 29.333 24 29.333C24.3537 29.333 24.6928 29.1925 24.9428 28.9425C25.1929 28.6924 25.3334 28.3533 25.3334 27.9997V26.533C26.8392 26.2256 28.1926 25.4074 29.1644 24.2169C30.1363 23.0263 30.667 21.5365 30.6667 19.9997Z"
        fill="#646676"
      />
      <Path
        d="M24 34.6667C24.7364 34.6667 25.3334 34.0697 25.3334 33.3333C25.3334 32.597 24.7364 32 24 32C23.2636 32 22.6667 32.597 22.6667 33.3333C22.6667 34.0697 23.2636 34.6667 24 34.6667Z"
        fill="#646676"
      />
    </Svg>
  );
};

export default EmptyBadge;
